<div class="min-h-screen max-h-screen h-full flex flex-col">
  <!-- Header -->
  <div
    class="relative z-60 flex justify-between items-center px-5 h-16 border-solid border-0 border-b border-gray-300 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
    <p-button size="large" styleClass="!px-2 !py-1" [severity]="'secondary'" [text]="true" (click)="menu.toggle($event)">
      <div class="flex flex-row items-center gap-3">
        <div class="flex flex-col gap-0 items-start">
          <img class="h-6" height="26" ngSrc="logo/long-logo.png" width="120" [alt]="businessName + ' Logo'" />
          @if (currentOrganisation$ | async; as organisation) {
            <div class="flex items-center gap-2 ml-2">
              <span class="font-semibold text-sm"> {{ organisation.name }} </span>
              @if (roleLabel(); as role) {
                <p-tag severity="secondary" styleClass="!text-[0.65rem] !py-0 !px-1.5" [value]="role" />
              }
            </div>
          }
        </div>
        <i class="pi pi-chevron-down transition-transform duration-200" [class.rotate-180]="menu.visible"></i>
      </div>
    </p-button>

    <div class="flex items-center gap-4">
      <p-toggleswitch class="-mb-1" [ngModel]="isDarkMode()" (onChange)="toggleDarkMode()">
        <ng-template #handle let-checked="checked">
          <i [ngClass]="['!text-xs pb-px', 'pi', checked ? 'pi-moon' : 'pi-sun']"></i>
        </ng-template>
      </p-toggleswitch>
      <button
        aria-label="Toggle sidebar"
        class="cursor-pointer block lg:hidden text-700 bg-transparent border-none"
        pRipple
        type="button"
        (click)="toggleSidebar()">
        <i class="pi pi-bars text-2xl"></i>
      </button>
    </div>
  </div>

  <div class="flex flex-row h-[calc(100vh-4rem)] min-h-[calc(100vh-4rem)]">
    <!-- Mobile sidebar overlay -->
    @if (isSidebarOpen()) {
      <div
        class="fixed inset-0 z-40 bg-black/40 lg:hidden"
        role="button"
        tabindex="0"
        (click)="closeSidebar()"
        (keydown.escape)="closeSidebar()"></div>
    }

    <!-- Sidebar -->
    <aside
      class="fixed inset-y-0 start-0 top-16 z-50 flex w-64 flex-col border-r border-gray-300 dark:border-surface-700 bg-surface-50 dark:bg-surface-900 transition-transform lg:static lg:top-0 lg:translate-x-0 select-none"
      [class.-translate-x-full]="!isSidebarOpen()"
      [class.translate-x-0]="isSidebarOpen()">
      <nav class="flex-1 space-y-1 px-3 py-4">
        @for (route of getMenuForRole((routeData$ | async).role); track $index) {
          <a
            class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 transition-colors hover:bg-gray-100 dark:hover:bg-surface-700 cursor-pointer"
            routerLinkActive="!bg-primary-100 !text-primary-700 dark:!bg-primary-900/50 dark:!text-primary-300"
            [routerLink]="route.path === '' ? ['/dashboard'] : ['/dashboard', route.path]"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeSidebar()">
            <i class="{{ route.data?.icon }}"></i>
            <span>{{ route.title }}</span>
          </a>
        }
      </nav>
    </aside>

    <!-- Main Content -->
    <div class="flex-auto overflow-y-auto bg-gray-100 dark:bg-surface-950">
      <router-outlet />
    </div>
  </div>
</div>

<p-menu #menu [model]="menuItems$ | async" [popup]="true">
  <ng-template #item let-item>
    @if (item.state) {
      <a
        class="p-menu-item-link !items-center !gap-3"
        role="menuitem"
        tabindex="0"
        (click)="item.command?.()"
        (keydown.enter)="item.command?.()">
        <p-avatar shape="circle" styleClass="!w-7 !h-7" [image]="item.state.avatar ? item.state.avatar : 'logo/logo.svg'" />
        <div class="flex flex-col gap-0.5">
          <span class="font-medium text-sm">{{ item.label }}</span>
          <div class="flex items-center gap-1">
            @if (item.state.role) {
              <p-tag severity="secondary" styleClass="!text-[0.65rem] !py-0 !px-1.5" [value]="item.state.role" />
            }
            @if (item.state.tier) {
              <p-tag severity="success" styleClass="!text-[0.65rem] !py-0 !px-1.5" [value]="item.state.tier" />
            } @else {
              <p-tag severity="warn" styleClass="!text-[0.65rem] !py-0 !px-1.5" value="No Plan" />
            }
          </div>
        </div>
      </a>
    } @else {
      <a
        class="p-menu-item-link"
        routerLinkActive="font-semibold !text-primary-500 dark:!text-primary-400"
        [routerLink]="item.routerLink"
        [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: true }">
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
      </a>
    }
  </ng-template>
</p-menu>
